import {
  Box,
  Typography,
  Stack,
  Avatar,
  Chip,
  Divider,
} from "@mui/material";
import { FiCalendar, FiUser } from "react-icons/fi";
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';

const PendingEncounterCard = ({ encounter, onclick, selectedPendingEncounter }) => {
  const initials = encounter.patient.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)

  return (
    <Box
      onClick={() => onclick(encounter)}
      sx={{
        p: 2,
        backgroundColor: selectedPendingEncounter && selectedPendingEncounter.id === encounter.id ? "#F0FDFA" : "#fff",
        borderRadius: 3,
        border: "1px solid #e5e7eb",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: "#5eead4",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        },
      }}
    >
      {/* TOP SECTION */}
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {/* Avatar */}
        <Avatar
          sx={{
            width: 52,
            height: 52,
            bgcolor: "#4db6ac",
            fontWeight: 600,
            fontSize: 18,
          }}
        >
          {initials}
        </Avatar>

        {/* Main Info */}
        <Stack spacing={0.8} flex={1}>
          <Typography fontWeight={600} fontSize={16}>
            {encounter.patient.name}
          </Typography>

          {/* Date */}
          <Stack direction="row" spacing={1} alignItems="center">
            <FiCalendar size={14} color="#64748b" />
            <Typography fontWeight={500} fontSize={13} color="#64748b">
              {new Date(encounter.date).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              }).replace(",", " •")}
            </Typography>

          </Stack>

          {/* Provider */}
          <Stack direction="row" spacing={1} alignItems="center">
            <FiUser size={14} color="#64748b" />
            <Typography fontWeight={500} fontSize={13} color="#64748b">
              Dr. {encounter.provider.name}
            </Typography>
          </Stack>

          {/* Procedures Count */}
          <Chip
            icon={<MedicalInformationIcon style={{fontSize: 16}} />}
            label={`${encounter.encountercpts.length} Procedures`}
            sx={{
              mt: 0.5,
              width: "fit-content",
              bgcolor: "#4db6ac",
              color: "#fff",
              fontWeight: 500,
              height: 32,
              borderRadius: 2,
              "& .MuiChip-icon": {
                color: "#fff",
              },
            }}
          />
        </Stack>
      </Stack>

      {/* Divider */}
      <Divider sx={{ my: 2 }} />

      {/* Bottom Row */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontWeight={500} fontSize={14} color="#64748b">
          {encounter.insurance.name}
        </Typography>

        <Chip
          label={encounter.actionmsg}
          sx={{
            bgcolor: encounter.actionmsg === "Approved" ? "#DCFCE7" : encounter.actionmsg === 'Rejected' ? '#FEE2E2' : "#FEF3C7",
            color: encounter.actionmsg === "Approved" ? "#28AB58" : encounter.actionmsg === 'Rejected' ? '#DC2626' : "#D97706",
            // color: "#16a34a",
            fontWeight: 600,
            borderRadius: 2,
            height: 30,
          }}
        />
      </Stack>
    </Box>
  );
};

export default PendingEncounterCard;
